import React from 'react' 
import Slider from "react-slick";

export default function Accommodation() {
    let settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 2,  
  
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }]
      };

  return (
    <>
  <section className="position-relative p70 ">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center mb-3 mb-md-4">
        Accommo<span className="color1">dation</span>
      </h2>
      <Slider className='man_c' {...settings}> 
          <div className="box1">
            <div className="overview_h">
              <img
                src="img/exterior.jpg"
                alt="exterior"
                className="img-fluid"
              />
            </div>
            <div className="box11">
              <h3>THE PLAZA Seoul Collection</h3>
              <p>
                The facilities have aged we exceptionally well. Lounge served
                free breakfast and food throughout the day for elite Titanium
                members. Gym was spacious and well equipped. Everyone was super
                friendly and courteous.
              </p>
            </div>
          </div>
        
          <div className="box1">
            <div className="overview_h">
              <img src="img/caption.jpg" alt="caption" className="img-fluid" />
            </div>
            <div className="box11">
              <h3>Hotel PJ Myeongdong</h3>
              <p>
                This hotel is located near the Mumbai International Airport and
                is a 25-minute drive from the Jio World Convention Centre. It
                offers modern rooms and suites, multiple dining options, a
                fitness center and an outdoor pool.{" "}
              </p>
            </div> 
        </div>
      </Slider>
     
     
    </div>
  </section>
    </>
  )
}
